import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {   footerInfoContact, footerInfoLogo } from "./FooterInfo";
import { Link , NavLink } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { baseURL, CAT } from "../../../Api/Api";
import { WindowSize } from "../../../context/WindowContext";

export default function Footer(){
    //context for size
    const mobSize=useContext( WindowSize);
    const windowSize =mobSize.windowSize

    const[cates,setCates]=useState([]);
    useEffect(()=>{
        try{
           axios.get(`${baseURL}/${CAT}`)
           .then((data)=>setCates(data.data));
        }
        catch(err){
           console.log(err);
        }
    },[]);
    //Mapping
    const dataShow1=footerInfoLogo.map((Item)=>
        <>
            <img style={{width:'130px'}} src={require('../../../image/Logo-footer.png')}/>
            <h5>{Item.description}</h5>
        </>
    );
    const dataShow2=footerInfoContact.map((item,key)=>
        <div key={key} className="d-flex ">
            <FontAwesomeIcon icon={item.icon} />
            <Link style={{marginInlineStart:'20px',textDecoration:'none', color:'white'}}
             to={item.Link}><h5>{item.contact}</h5></Link>
        </div>
    );
    const dataShow3=cates.map((item,key)=>
        <div key={key} >
            <NavLink  to={`/category/${item.id}`} style={{textDecoration:'none',color:'white'}}>
        <h5>{item.title.length>20?item.title.slice(0,14) + '...':item.title}</h5></NavLink>
        </div>
    )
    return(
        <div className="W-100 p-3" style={{backgroundColor:'var(--bachgroundColorFooter)'}}>
            <div className="footer-div-parent container 
            flex-wrap d-flex align-items-start pt-3 justify-content-between "
             style={{color:'white',gap:'40px 0'}}>
                <div className="footer-div footer-logo d-flex flex-column gap-4">{dataShow1}</div>
                <div className="footer-div footer-contact d-flex flex-column gap-4">
                  <h4>Contact us :</h4>
                    {dataShow2}
                    </div>
                {windowSize>'768'&&<div className="footer-div footer-nav d-flex ">{dataShow3}</div>}
            </div>
            
        </div>
    );
}